import { apiFetch } from "../fetchApi";

export const createSPOC = async (BeURL, showAlert, payload, setSpoc, navigate) => {
    try {


        // 2️⃣ Send companyId as query param for account creation
        const accountRes = await apiFetch(`${BeURL}/create-spoc`, {
            method: "POST",

            body: JSON.stringify(payload), // FormData (images/files)
        });

        const accountData = await accountRes.json();
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }

        showAlert(accountData.message);
        setSpoc({
            firstName: '',
            lastName: '',
            fullName: '',
            email: '',
            alternateEmail: '',
            contact: '',
            alternateContact: '',
            designation: '',
            location: '',
        })
        setTimeout(() => {
            navigate('/list-clients')
        }, 1000);


    } catch (err) {
        console.error("Error in SPOC create:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
};


export const fetchSpoc = async (BeURL, showAlert, setSpoc, spocId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/spoc/${spocId}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setSpoc(data.Spocdata)


    } catch (err) {
        console.error("Error in Update the SPOC:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const fetchAllSpoc = async (BeURL, showAlert, setSpoc, companyId, clientId, currentPage, rowsPerPage, setTotalSpoc, setTotalPage) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/client-spoc/${clientId}/${companyId}`, {
            method: "POST",
            body: JSON.stringify({ pages: currentPage, spocPerPage: rowsPerPage })
        });

        const data = await res.json();

        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setSpoc(data.clientSpoc)
        setTotalSpoc(data.totalSpoc)
        setTotalPage(data.totalPages)


    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const updateSpoc = async (BeURL, showAlert, payload, setSpoc, spocId, navigate) => {
    try {


        // 2️⃣ Send companyId as query param for account creation
        const accountRes = await apiFetch(`${BeURL}/update-spoc/${spocId}`, {
            method: "POST",

            body: JSON.stringify(payload), // FormData (images/files)
        });

        const accountData = await accountRes.json();
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }

        showAlert(accountData.message);
        setSpoc({
            firstName: '',
            lastName: '',
            fullName: '',
            email: '',
            alternateEmail: '',
            contact: '',
            alternateContact: '',
            designation: '',
            location: '',
        })
        setTimeout(() => {
            navigate(-1)
        }, 1000);


    } catch (err) {
        console.error("Error in Client create:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
};

export const SPOCConfirm = async (BeURL, showDeleteConfirm, showAlert, spocId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/spoc-delete/${spocId}/confirm`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        const confirmed = await showDeleteConfirm(data.message);
        return confirmed;


    } catch (err) {
        console.error("Error in Delete client confrimation:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const deleteSPOC = async (BeURL, showAlert, spocId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/spoc-delete/${spocId}`, {
            method: "delete",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        showAlert(data.message)
        window.location.reload()


    } catch (err) {
        console.error("Error in Delete client :", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

// fetch All SPOC based on the companyId:
export const fetchCompanySpocs = async (BeURL, showAlert, setAllSpocsList, companyId) => {
    try {
        console.log("LAll spocs")
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/spoc-data/${companyId}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setAllSpocsList(data.companySpoc)
        console.log("All spoc is called why??")

    } catch (err) {
        console.error("Error in Fetch All Company SPOC:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

// Fetch Spoc Based on the company and client without Pagination ofr the report 
export const fetchCompanyClientSpocs = async (BeURL, showAlert, setAllSpocsList, companyId, clientId) => {
    try {

        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/clientSpoc/${clientId}/${companyId}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setAllSpocsList(data.clientSpoc)
        console.log("All spoc is called why??")

    } catch (err) {
        console.error("Error in Fetch All Company Client SPOC:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}